export const getCaseDate = (caseItem) => new Date(caseItem.created_at || caseItem.updated_at || 0);

export const toDateInput = (date) => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export const filterCasesByDate = (cases, from, to) => {
  const start = from ? new Date(`${from}T00:00:00`) : new Date(0);
  const end = to ? new Date(`${to}T23:59:59.999`) : new Date(8640000000000000);
  return cases.filter((caseItem) => {
    const date = getCaseDate(caseItem);
    return !Number.isNaN(date.getTime()) && date >= start && date <= end;
  });
};

export const countBy = (items, field, fallback = 'Not specified') => items.reduce((counts, item) => {
  const key = item[field] || fallback;
  counts[key] = (counts[key] || 0) + 1;
  return counts;
}, {});

export const downloadCasesCsv = (cases, fileName) => {
  const fields = [
    ['Reference number', 'web_reference_number'],
    ['Created date', 'created_at'],
    ['Status', 'status'],
    ['Vehicle plate', 'vehicle_plate'],
    ['Make', 'make'],
    ['Model', 'model'],
    ['Body type', 'body_type'],
    ['Reason for inspection', 'reason_for_inspection'],
    ['Customer email', 'customer_email'],
    ['Assigned to', (item) => item.users?.username || ''],
  ];
  const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
  const rows = [
    fields.map(([label]) => escape(label)).join(','),
    ...cases.map((item) => fields.map(([, key]) => escape(typeof key === 'function' ? key(item) : item[key])).join(',')),
  ];
  const url = URL.createObjectURL(new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
